import { NavigateFunction, NavigateOptions } from "react-router-dom";

class NavigationService {
	private static _navigate: NavigateFunction | null = null;

	static set(navigateFn: NavigateFunction) {
		this._navigate = navigateFn;
	}

	static go(path: string, options?: NavigateOptions) {
		if (!this._navigate) {
			console.warn("NavigationService: navigate가 아직 설정되지 않았습니다.");
			return;
		}
		this._navigate(path, options);
	}

	static getNavigate() {
		if (!this._navigate) {
			throw new Error("NavigationService: navigate가 설정되지 않았습니다.");
		}
		return this._navigate;
	}

	static isReady() {
		return this._navigate !== null;
	}
}

export default NavigationService;
